<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RkTDIF/tc-custom/9781646040964.jpg?1718184632626" alt="This image is the cover for the book Somatic Therapy Workbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Somatic Therapy Workbook
      </h1>
      <p class="bookDescription body article font2">
        <b>Release tension and heal from traumatic experiences with therapist-approved activities in this easy-to-use guide to somatic therapy.</b><br/><br/><i>Enjoy a great reading experience, with a $3 credit back to spend on your next Great on Kindle book when you buy the Kindle edition of this book.</i><br/><br/> The effects of a traumatic event are more than just mental. Trauma can manifest in the body as chronic pain, sluggishness, and even depressed mood. Somatic psychology is an alternative therapy that analyzes this mind-body connection and helps you release pent-up tension and truly heal from past trauma. <i>The Somatic Therapy Workbook</i> offers a primer to this life-changing approach as a means for personal growth, designed for beginners or those already using somatic techniques in their current therapeutic process. Ideal for those suffering from PTSD and other trauma-based afflictions, this safe and approachable look at somatic therapy includes:<br/><br/> - journal exercises<br/><br/> - body-centered prompts for personal inquiry<br/><br/> - movement exercises<br/><br/> - real-life experiments<br/><br/> Discover a new ability to process and accept your emotions—and an understanding of how to live a somatically-oriented and embodied life. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Livia Shapiro
      </h2>
      
      <p class="authorDescription body article">Livia Shapiro is a fresh and radically honest voice, illuminating somatic psychology as a practical, meaningful and engaging theoretical paradigm and practice for personal inquiry and healing. She speaks to clinicians, students, clients, and the lay person alike with a kind clarity and witty humor. She has been interviewed by countless podcasts on somatic psychology, yoga, trauma sensitive yoga, and embodied spiritual practice. In clinical practice, Livia works holistically assisting women in healing from trauma, repairing relational wounds, and rewiring their nervous systems so they can live more vibrantly and powerfully in the lives they choose. She graduated Cum Laude from the University of Vermont, holds a Masters of Somatic Counseling Psychology from Naropa University, and is a registered psychotherapist with the state of Colorado.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06e293ae